import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import closingBg from "@/assets/closing/closing-bg.jpeg";

interface ClosingSectionProps {
  bgUrl?: string | null;
}

export function ClosingSection({ bgUrl }: ClosingSectionProps) {
  const [invitedName, setInvitedName] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const encryptedName = params.get("x");
    if (encryptedName) {
      const decodedName = atob(encryptedName);
      setInvitedName(decodedName);
    }
  }, []);

  return (
    <section className="relative w-full h-[60vh] md:h-[80vh] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={bgUrl || closingBg}
          alt="Closing Background"
          className="w-full h-full object-cover"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4">
        <motion.h2
          className="font-handwriting text-5xl md:text-7xl text-white mb-6"
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          See you there!
        </motion.h2>

        {invitedName && (
          <motion.div
            className="font-serif text-2xl md:text-4xl text-white mb-4 font-bold"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3, duration: 0.8 }}
          >
            {invitedName}
          </motion.div>
        )}

        <motion.p
          className="font-serif text-lg md:text-2xl text-white/90"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4, duration: 0.8 }}
        >
          Sampai Jumpa di Hari Bahagia Kami
        </motion.p>

        <motion.p
          className="text-xs md:text-sm tracking-widest text-white/60 mt-8 font-semibold"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.6, duration: 0.8 }}
        >
          #RIFAllforeverwithNAUVAL
        </motion.p>
      </div>
    </section>
  );
}
